module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/11H222m/media/FC-9798886934441.jpg?1701092759691",
      "alt": "This image is the cover for the book Christianity as the Moral Order of Integration"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Christianity as the Moral Order of Integration\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', {
    staticStyle: {
      "margin-top": "0cm",
      "margin-right": "0cm",
      "margin-bottom": "8.0pt",
      "margin-left": "0cm",
      "font-size": "15px",
      "font-family": "\"Calibri\",sans-serif"
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "16px",
      "font-family": "\"Arial\",sans-serif",
      "color": "black"
    }
  }, [_vm._v("This book is an integration of the Old and New Testaments, and it is intended to demonstrate that there should be only one Testament. Together they form the Bible of the Jewish people. They unfold the long journey that Abram and Sarai were summoned by God to initiate. As migrants without a country and without an ethnic identity, they personified the Truth of God by incarnating “the Lord God’s” being of presence and transcendent possibility. Incorporated into an eternal covenant as Abraham and Sarah, they established the birthright of God’s elect people as the embodiment of the integration of universality and ethnicity.")])]), _c('p', {
    staticStyle: {
      "margin-top": "0cm",
      "margin-right": "0cm",
      "margin-bottom": "8.0pt",
      "margin-left": "0cm",
      "font-size": "15px",
      "font-family": "\"Calibri\",sans-serif"
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "16px",
      "font-family": "\"Arial\",sans-serif",
      "color": "black"
    }
  }, [_vm._v("The journey continued through their descendants, vacillating between the union of universality and ethnicity and mere ethnicity, and, in the course of Israel’s history, it separated the prophets from the priests. The journey traverses the Yahwist Strand of the Pentateuch, the four prophetic divisions of the Book of Isaiah, Book 1 of I Enoch, the Apocalypse of Daniel, John the Baptist, and it climaxes in the ontological termination of the moral order of separation through the death of Jesus of Nazareth and the inauguration of a New Creation and its New Humanity through his resurrection from the dead.")])]), _c('p', {
    staticStyle: {
      "margin-top": "0cm",
      "margin-right": "0cm",
      "margin-bottom": "8.0pt",
      "margin-left": "0cm",
      "font-size": "15px",
      "font-family": "\"Calibri\",sans-serif"
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "16px",
      "font-family": "\"Arial\",sans-serif",
      "color": "black"
    }
  }, [_vm._v("The journey is concluded by Paul the Apostle who, as an ethnically determined Pharisee, is called by God to proclaim the moral order of integration as a gift to the nations of the Gentiles.")])]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Herman C. Waetjen\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }), _c('p', {
    staticStyle: {
      "margin-right": "0cm",
      "margin-left": "0cm",
      "font-size": "16px",
      "font-family": "\"Times New Roman\",serif",
      "margin": "0cm",
      "text-align": "justify",
      "background": "white"
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "15px",
      "color": "black",
      "padding": "0cm",
      "background": "white"
    }
  }, [_vm._v("Herman C. Waetjen, Dr. Theol (Eberhard-Karls University of Tübingen, Germany), taught in the School of Religion of the University of Southern California, and as the Robert S. Dollar Professor of New Testament at San Francisco Theological Seminary in San Anselmo and the Graduate Theological Union in Berkeley for 40 years. He is the author of five books: "), _c('em', [_vm._v("Matthew’s Theology of Fulfillment, The Letter to the Romans: Salvation as Justice and the Deconstruction of Law, The Gospel of the Beloved Disciple: A Work in Two Editions, Praying the Lord’s Prayer, ")]), _vm._v("and "), _c('em', [_vm._v("A Reordering of Power: A Socio-Political Reading of Mark’s Gospel.")])])]), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Austin Macauley Publishers\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0